import React, { useEffect, useState } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavbarCollapse from 'react-bootstrap/esm/NavbarCollapse';
import { Container } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';

import { currentMenuItems } from '../../../common/navigation';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { useAuth } from '../../../common/hooks/useAuth';
import { AuthState } from '../../../common/auth';
import ProfileButton from '../ProfileButton';
import { useNotifications } from '../../../common/hooks/useNotifications';
import ConnectionIssues from '../ConnectionIssues';
import MessageDialogModal from '../MessageDialogModal';
import Logo from '../Logo/Logo';

import { MainNavSection } from './MainNavSection';

interface NavMainProps {
  activePage: string;
}

const NavMain: React.FC<NavMainProps> = ({ activePage }) => {
  const productBackground = process.env.REACT_APP_BACKGROUND || '#539A61';
  const developBackground = process.env.REACT_APP_BACKGROUND || '#4d7298';
  const backgroundColor =
    process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
      ? developBackground
      : productBackground;
  const spdApi = useSpdCore();
  const authFirebase = useAuth();
  const notifications = useNotifications();

  const [currentLinks, setCurrentLinks] = useState(
    currentMenuItems(
      authFirebase.state === AuthState.LoggedIn,
      authFirebase?.roles,
    ),
  );

  useEffect(() => {
    setCurrentLinks(
      currentMenuItems(
        authFirebase.state === AuthState.LoggedIn,
        authFirebase?.roles,
      ),
    );
  }, [authFirebase.state, activePage, authFirebase, spdApi.users]);

  notifications.noBackend = () => {
    toast.error('Brak połączenia z serwerem');
  };

  notifications.unauthorized = () => {
    toast.error('Brak uprawnień do wykonania tej operacji');
  };

  return (
    <>
      <Navbar
        expand="xl"
        collapseOnSelect
        variant="dark"
        role="banner"
        as="header"
        className="mainbar"
        style={{ backgroundColor: backgroundColor }}
      >
        <Container fluid>
          <Navbar.Brand href="/" className="me-auto navbar-logo">
            <Logo />
          </Navbar.Brand>
          <div className="d-none d-xl-block">
            <ProfileButton activePage={activePage} />
          </div>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <NavbarCollapse id="basic-navbar-nav">
            <Nav className="me-auto">
              {currentLinks.map(({ path, heading, className, submenu, hr }) => {
                return (
                  <MainNavSection
                    className={'mainbarlink ' + className}
                    key={path}
                    heading={heading}
                    path={path}
                    activePage={activePage}
                    items={submenu}
                    hr={hr}
                  />
                );
              })}
            </Nav>
            <Nav className="d-xl-none">
              <ProfileButton activePage={activePage} />
            </Nav>
          </NavbarCollapse>
        </Container>
      </Navbar>
      <ToastContainer />
      <MessageDialogModal />
      <ConnectionIssues />
    </>
  );
};

export default NavMain;
